// initial state

const SME_STATE = "SME";
const PRODUCT_STATE = "PRODUCT";

const state = () => ({
  dashboardState: SME_STATE,
  productData: [],
  loadingDataCount: true,
});

const actions = {
  ChangeStateToSME({ commit }) {
    commit("ChangeState", SME_STATE);
  },
  ChangeStateToProduct({ commit }) {
    commit("ChangeState", PRODUCT_STATE);
    this.dispatch("map/sliceData", 1);
  },
  ChangeProductData({ commit }, productData) {
    commit("ChangeProductData", productData);
  },
  ChangeLoadingDataCount({ commit }, bool) {
    commit("ChangeLoadingDataCount", bool);
  },
};

const mutations = {
  ChangeLoadingDataCount(state, bool) {
    state.loadingDataCount = bool;
  },
  ChangeState(state, value) {
    state.dashboardState = value;
  },
  ChangeProductData(state, productData) {
    state.productData = productData;
  },
};

const getters = {
  getDashboardState: (state) => state.dashboardState,
  isSME_STATE: (state) => state.dashboardState === SME_STATE,
  isPRODUCT_STATE: (state) => state.dashboardState === PRODUCT_STATE,
  getProductTotalByProvinceName: (state) => (provinceName) => {
    const result = state.productData.find(
      (el) => el.PROVINCE_NAME === provinceName
    );
    if (result) return result.TOTAL;
    return 0;
  },
  getProductTotalByAumphurName: (state) => (aumphurName) => {
    const result = state.productData.find(
      (el) => el.AMPHUR_NAME === aumphurName
    );
    if (result) return result.TOTAL;
    return 0;
  },
  getProductTotalByTambonName: (state) => (tambonName) => {
    const result = state.productData.find(
      (el) => el.TAMBOL_NAME === tambonName
    );
    if (result) return result.TOTAL;
    return 0;
  },
  getLoadingDataCount: (state) => state.loadingDataCount,
};

export {
  state,
  getters,
  actions,
  mutations,
};
